import {
  PlusOutlined,
  CaretUpFilled,
  MinusOutlined,
  CaretDownFilled,
} from "@ant-design/icons";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";
import Style from "./style";

export default function OverviewMapControllers({
  documentationCollapsed,
  zoomHandler = () => {},
  moveUpHandler = () => {},
  zoomOutHandler = () => {},
  moveDownHandler = () => {},
}) {
  return (
    <Style
      className={formatClassname(['map-handlers', documentationCollapsed && 'collapsed'])}
    >
      <button onClick={zoomHandler}>
        <PlusOutlined />
      </button>
      <button onClick={zoomOutHandler}>
        <MinusOutlined />
      </button>
      <button onClick={moveUpHandler} className="up">
        <CaretUpFilled />
      </button>
      <button onClick={moveDownHandler} className="down">
        <CaretDownFilled />
      </button>
    </Style>
  )
}
